import React, { useEffect, useState } from "react";
import {
  SlDrawer,
  SlButton,
  SlIcon
} from "@shoelace-style/shoelace/dist/react";
import API from "../../services/api";
import {useForm} from 'react-hook-form'
import {Toast} from '../../shared/Toast'
import { formatDate, formatDateYYYYMMDD } from "../../utils/dateFormat";

import { roles } from "../../utils/constants";
// import { socket } from "../../socket";
// development
// const socket = io.connect("http://localhost:4040") 
// production
function OrderPayment(props) {
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [showForm ,setShowForm] = useState(false)
  const [editPayment, setEditPayment] = useState(false)
  const [editData, setEditData] = useState({})
  const [paymentId, setPaymentId] = useState()
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const handleClose = () => {
    props.setShow();
    props.loadData()
  };

  const form1 = useForm({ mode: "onSubmit" });

  const fetchPaymentDetails = async () => {
    try {
      let res = await API({
        url: "/invoice/fetch-payments",
        method: "POST",
        responseType: "json",
        data: {
          order_id: props.order_id,
          invoice_id:props.invoice_id
        },
      });
      if (res.code === 200) {
        setPaymentDetails(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onSubmit = async(data) =>{
    if(editPayment){
      try {
        let res = await API({
          url:'/invoice/edit-payments',
          method:'POST',
          responseType:'json',
          data:{
            amount:data.amount,
            mode:data.mode,
            source:data.mode === "online" ? data.source : null,
            transcation_id:data.transcation_id,
            payment_date:data.payment_date,
            payment_id:paymentId,
            order_id:props.order_id,
            invoice_id:props.invoice_id
          }
        })
        if(res.code === 200){
          // socket.emit("order_update",{
          //   message:"Order payment was updated",
          //   order_id: props.order_id,
          //   order_name:props.orderName,
          //   user:localStorage.getItem('name')
          // })
          // socket.off("order_update")
          fetchPaymentDetails()
          form1.reset()
          Toast('success', "Payments update Successfully!")
          setShowForm(false)
        }
        else{
          Toast('error', "Something went wrong!")
        }
      } catch (error) {
        console.error(error)
      }
    }
    else{
    try {
      let res = await API({
        url:'/invoice/add-payments',
        method:'POST',
        responseType:'json',
        data:{
          amount:data.amount,
          mode:data.mode,
          source:data.mode === "online" ? data.source : null,
          transcation_id:data.transcation_id,
          order_id :props.order_id,
          invoice_id:props.invoice_id,
          payment_date:data.payment_date
        }
      })
      if(res.code === 200){
        // socket.emit("order_update",{
        //   message:"Order payment was updated",
        //   order_id: props.order_id,
        //   order_name:props.orderName,
        //   user:localStorage.getItem('name')
        // })
        // socket.off("order_update")
        fetchPaymentDetails()
        form1.reset()
        Toast('success', "Payments update Successfully!")
        setShowForm(false)
      }
      else{
        Toast('error', "Something went wrong!")
      }
    } catch (error) {
      console.error(error)
    }
  }
  }
  const BankingOptions = [
    {value:"cheque", label:"Cheque"},
    {value:"upi", label:"UPI"},
    {value:"bank", label:"Bank Transfer"},
    {value:"online", label:"Online Transcation"}
  ]

  const watchMode = form1.watch('mode')

  useEffect(() => {
    if (props.order_id) fetchPaymentDetails();
  }, [props.order_id]);



  useEffect(() =>{
    if(editPayment){
      form1.setValue('amount',editData.amount)
      form1.setValue('mode',editData.mode)
      form1.setValue('source',editData.source)
      form1.setValue('transcation_id',editData.transcation_id)
      form1.setValue('payment_date',formatDateYYYYMMDD(editData.payment_date))
    }
  },[editPayment])


  return (
    <>
      <SlDrawer
        label="Order payment Details"
        open={props.show}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={handleClose}
        style={{ "--size": "767px" }}
      >
        <h2 className="text-center">PaymentDetails of {props.orderName}</h2>
        <div className="overflow-x-auto my-4">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>S.NO</th>
                <th>Mode</th>
                <th>Transcation Id</th>
                <th>Time</th>
                <th>Update By</th>
                <th>Amount</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paymentDetails?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.mode === "online" ? item.mode  + "/" + item.source : item.mode}</td>
                    <td>{item.transcation_id}</td>
                    <td>{formatDate(item.payment_date) || "-"}</td>
                    <td>{item.name || "-"}</td>
                    <td>{item.amount}</td>
                    <td><SlIcon onClick={() => {setEditPayment(true); setShowForm(true); setEditData(item); setPaymentId(item.payment_id)}} library="lucide" name="pencil" className="cursor-pointer"></SlIcon></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          </div>
         {localStorage.getItem('role') === roles.financer &&  <SlButton variant="primary" size="small" onClick={()=>{setShowForm(true)}}>
            Add Payment
          </SlButton>}

         {showForm && <div className="mx-auto mt-3 max-w-screen-sm px-3 py-3 border border-dark">
              <form onSubmit={form1.handleSubmit(onSubmit)}>
                <div className="mb-3 d-flex justify-between">
                <h3>Enter Payment Details</h3>
                <button className="btn btn-outline-danger btn-sm rounded-circle" onClick={()=>{setShowForm(false); form1.reset(); setEditData({}); setEditPayment(false)}}>X</button>
                </div>                      
             <> <div className="mb-3">
                <label className="form-label">Mode of Payment</label>
                <span className="text-red-600">*</span>
            
                    <select
                      name="mode"
          {...form1.register('mode', { required: true })}
                      className="form-select"
                      classNamePrefix="select"
                    >
                      <option value="">Select Mode</option>
                      {BankingOptions.map((item, index) => {
                        return (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        )
                      })}
                    </select>
                {form1.formState.errors?.mode ? (
                  <span className="red-text">Payment is required!</span>
                ) : null}
              </div>
              {watchMode === "online" && <div className="mb-3">
                <label className="form-label">Source</label>
                <span className="text-red-600">*</span>
                <input className="form-control" placeholder="Enter Source" {...form1.register('source', {required:watchMode?.value === "online"})}></input>
                {form1.formState.errors?.source ? (
                  <span className="red-text">Source is required!</span>
                ) : null}
              </div>}
              <div className="mb-3">
                  <label className="form-label">Transcation ID</label>
                  <span className="text-red-600">*</span>

                  <input className="form-control" placeholder="Enter transcation Id" {...form1.register('transcation_id',{required:true})}></input>
                  {form1.formState.errors?.transcation_id ? (
                  <span className="red-text">Transcation Id is required!</span>
                ) : null}
              </div>
              <div className="mb-3">
                <label className="form-label">Payment Date</label>
                <span className="text-red-600">*</span>

                <input className="form-control" type="date" {...form1.register('payment_date',{required:true})}></input>
                {form1.formState.errors?.payment_date ? (
                  <span className="red-text">Payment Date is required!</span>
                ) : null}
              </div>
              <div className="mb-3">
                  <label className="form-label">Amount</label>
                  <span className="text-red-600">*</span>

                  <input className="form-control" type="number" placeholder="Enter Amount" {...form1.register('amount',{required:true, min:1})}></input>
                  {form1.formState.errors?.amount ? (
                  <span className="red-text">Enter Valid amount!</span>
                ) : null}
              </div>
              <SlButton size="small" variant="primary" type="submit">Submit</SlButton></>
              </form>
          </div>}

      </SlDrawer>
    </>
  );
}

export default OrderPayment;
